import _toConsumableArray from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import Toggle from "../../_global/Toggle";
import { customFonts, layoutSizes, fontSizes, colours, zIndexes, pixel, mobileHeaderHeight } from "../../../constants/css";
import useWindowDimensions from "../../../utils/useWindowDimensions";
import isBrowser from "../../../utils/isBrowser";
var NavItem = styled.a.withConfig({
  displayName: "Nav__NavItem",
  componentId: "sc-yzvsbn-0"
})(["color:", ";cursor:pointer;pointer-events:", ";padding:0.5rem 0.725rem;text-align:center;font-size:", ";text-decoration:underline;&:hover{color:", ";}@media only screen and (min-width:", "){padding:0;font-size:", ";}@media only screen and (max-width:", "){display:inline-block;font-size:", ";font-weight:500;text-decoration:none;height:100%;line-height:2.75rem;white-space:nowrap;padding:0;margin-right:1.5rem;", "}"], function (props) {
  return props.isActive ? '#000000' : '#D5D5D5';
}, function (props) {
  return !props.isActive && 'none';
}, fontSizes.large, colours.qantasRed, layoutSizes.desktopWidth, fontSizes.base, layoutSizes.mobileWidth, fontSizes.large, function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected && "color: ".concat(colours.qantasRed);
});
var NavWithFilterContainer = styled.div.withConfig({
  displayName: "Nav__NavWithFilterContainer",
  componentId: "sc-yzvsbn-1"
})(["@media only screen and (min-width:", "){position:sticky;justify-content:space-around;top:0px;z-index:", ";background-color:white;flex-wrap:nowrap;padding:0.75rem;flex-flow:inherit;}@media only screen and (max-width:", "){position:sticky;top:", ";z-index:", ";}flex-flow:column-reverse;display:flex;"], layoutSizes.desktopWidth, zIndexes.alphbetNav, layoutSizes.mobileWidth, pixel(mobileHeaderHeight), zIndexes.alphbetNavMobile);
var BonusItem = styled.a.withConfig({
  displayName: "Nav__BonusItem",
  componentId: "sc-yzvsbn-2"
})(["margin-top:0.5rem;text-align:center;white-space:nowrap;font-size:", ";color:", ";font-family:", ";font-weight:500;span{margin-right:1rem;margin-left:1rem;}@media only screen and (min-width:", "){padding:0;font-size:", ";}"], fontSizes.large, colours.qantasCharcoal, customFonts.ciutadellaMed, layoutSizes.desktopWidth, fontSizes.base);
var NavContainer = styled.div.withConfig({
  displayName: "Nav__NavContainer",
  componentId: "sc-yzvsbn-3"
})(["display:flex;width:100%;justify-content:center;align-items:center;flex-wrap:wrap;border:1px solid #d5d5d5;padding:0.375rem;@media only screen and (min-width:", "){justify-content:space-around;flex-wrap:nowrap;padding:0.75rem;}@media only screen and (max-width:", "){width:100%;background-color:", ";display:block;height:2.75rem;overflow:hidden;padding:0;border-width:0.5px 0 0.5px 0;border-style:solid;border-color:", ";.navContainer-child{width:100%;display:flex;overflow-x:scroll;padding-bottom:50px;margin-bottom:-50px;> a:last-of-type{margin-right:0;}.padding{display:block;min-width:1rem;}}}"], layoutSizes.desktopWidth, layoutSizes.mobileWidth, colours.qantasMediumGrey, colours.qantasBorderLightGrey);
// eslint-disable-next-line react/prop-types
var NavContainerWrapper = function NavContainerWrapper(_ref2) {
  var isMobile = _ref2.isMobile,
    children = _ref2.children;
  return __jsx(NavContainer, null, isMobile ? __jsx("div", {
    className: "navContainer-child"
  }, __jsx("span", {
    className: "padding"
  }), children, __jsx("span", {
    className: "padding"
  })) : __jsx(React.Fragment, null, children));
};
var MerchantListNav = function MerchantListNav(props) {
  // eslint-disable-next-line react/prop-types
  var groups = props.groups,
    bonus = props.bonus,
    selectedLetter = props.selectedLetter,
    setSelectedLetter = props.setSelectedLetter;
  var _useWindowDimensions = useWindowDimensions(),
    _useWindowDimensions$ = _useWindowDimensions.isMobile,
    isMobile = _useWindowDimensions$ === void 0 ? true : _useWindowDimensions$;
  var alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

  // Sort to put '0-9' in front
  var sortedGroups = [groups[26]].concat(_toConsumableArray(groups.slice(0, 26)));
  var _useState = useState(undefined),
    firstValidLetter = _useState[0],
    setFirstValidLetter = _useState[1];
  useEffect(function () {
    var letter = groups.find(function (group) {
      return group.merchants.length > 0;
    }).firstLetter;
    setFirstValidLetter(letter);
    setSelectedLetter(letter);
  }, []);
  var scrollToLetter = function scrollToLetter(letter) {
    if (firstValidLetter === letter) {
      isBrowser && window.scrollTo(0, 0);
    } else {
      setTimeout(function () {
        return document.querySelector("#stores".concat(letter)).scrollIntoView();
      }, 0);
    }
  };
  var isPortrait = isBrowser === true ? window.matchMedia('(orientation: portrait)').matches : undefined;
  useEffect(function () {
    if (isPortrait !== undefined && selectedLetter !== undefined) {
      scrollToLetter(selectedLetter);
    }
  }, [isPortrait]);
  var handleSelectLetter = function handleSelectLetter(letter) {
    setSelectedLetter(letter);
    scrollToLetter(letter);
  };
  return __jsx(NavWithFilterContainer, null, __jsx(NavContainerWrapper, {
    isMobile: isMobile
  }, sortedGroups.map(function (group) {
    var isActive = group.merchants.length > 0;
    return __jsx(NavItem, {
      onClick: function onClick() {
        return isActive && handleSelectLetter(group.firstLetter);
      },
      isActive: isActive,
      isSelected: group.firstLetter === selectedLetter,
      key: group.firstLetter
    }, group.firstLetter);
  })), !isMobile && __jsx(BonusItem, null, __jsx("span", null, "Bonus Points"), __jsx(Toggle, {
    checked: bonus,
    onChange: function onChange(checked) {
      var notBonus = document.querySelectorAll("[id^='notbonus']");
      notBonus.forEach(function (nb) {
        // eslint-disable-next-line no-param-reassign
        nb.style.display = checked ? 'none' : 'flex';
      });
      alphabet.forEach(function (letter) {
        var storesBar = document.querySelector("[id=stores".concat(letter.toUpperCase(), "]"));
        if (!storesBar) {
          return;
        }
        if (checked) {
          var bonusForLetter = document.querySelectorAll("[id='bonus_".concat(letter, "']"));
          storesBar.style.display = bonusForLetter.length === 0 ? 'none' : 'unset';
        } else {
          storesBar.style.display = 'unset';
        }
      });
      window.history.pushState('', '', "".concat(window.location.pathname, "?bonus=").concat(checked));
    }
  })));
};
export default MerchantListNav;